import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { DEFAULT_PROJECT_NAME, DEFAULT_TITLE } from '@/constants/constants'

const Head: React.FC = () => {
  const title =
    useSelector(migrationProjectSelector.getProjectTitle) ||
    DEFAULT_PROJECT_NAME
  const projectId = useSelector(migrationProjectSelector.getProjectId)

  useEffect(() => {
    if (projectId) {
      document.title = `${title} | Octopus.do`
    } else {
      document.title = DEFAULT_TITLE
    }
  }, [title, projectId])

  return null
}

export default Head
